var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_403_2952)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 6.0003H23C23.2652 6.0003 23.5196 5.89494 23.7071 5.70741C23.8946 5.51987 24 5.26552 24 5.0003C24 4.73509 23.8946 4.48073 23.7071 4.2932C23.5196 4.10566 23.2652 4.00031 23 4.00031H7C6.73478 4.00031 6.48043 4.10566 6.29289 4.2932C6.10536 4.48073 6 4.73509 6 5.0003C6 5.26552 6.10536 5.51987 6.29289 5.70741C6.48043 5.89494 6.73478 6.0003 7 6.0003Z",
    fill: "#374957"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 10.9997H7C6.73478 10.9997 6.48043 11.1051 6.29289 11.2926C6.10536 11.4801 6 11.7345 6 11.9997C6 12.2649 6.10536 12.5193 6.29289 12.7068C6.48043 12.8943 6.73478 12.9997 7 12.9997H23C23.2652 12.9997 23.5196 12.8943 23.7071 12.7068C23.8946 12.5193 24 12.2649 24 11.9997C24 11.7345 23.8946 11.4801 23.7071 11.2926C23.5196 11.1051 23.2652 10.9997 23 10.9997Z",
    fill: "#374957"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 18H7C6.73478 18 6.48043 18.1054 6.29289 18.2929C6.10536 18.4804 6 18.7348 6 19C6 19.2652 6.10536 19.5196 6.29289 19.7071C6.48043 19.8947 6.73478 20 7 20H23C23.2652 20 23.5196 19.8947 23.7071 19.7071C23.8946 19.5196 24 19.2652 24 19C24 18.7348 23.8946 18.4804 23.7071 18.2929C23.5196 18.1054 23.2652 18 23 18Z",
    fill: "#374957"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 6.99999C3.10457 6.99999 4 6.10456 4 5C4 3.89543 3.10457 3 2 3C0.89543 3 0 3.89543 0 5C0 6.10456 0.89543 6.99999 2 6.99999Z",
    fill: "#374957"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 14.0003C3.10457 14.0003 4 13.1049 4 12.0003C4 10.8957 3.10457 10.0003 2 10.0003C0.89543 10.0003 0 10.8957 0 12.0003C0 13.1049 0.89543 14.0003 2 14.0003Z",
    fill: "#374957"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 20.9997C3.10457 20.9997 4 20.1043 4 18.9997C4 17.8951 3.10457 16.9997 2 16.9997C0.89543 16.9997 0 17.8951 0 18.9997C0 20.1043 0.89543 20.9997 2 20.9997Z",
    fill: "#374957"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_403_2952"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.184e1965427700e6628922ab29ba0171.svg";
export { ForwardRef as ReactComponent };